import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.scss';

export default function ForumPanel({
  className,
  id,
  children,
}: {
  className?: string;
  id?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={clsx(styles.forumPanel, className)} id={id}>
      {children}
    </div>
  );
}
